
import state from './modulePurchaseOrdersManagementState'
import mutations from './modulePurchaseOrdersManagementMutations'
import actions from './modulePurchaseOrdersManagementActions'
import getters from './modulePurchaseOrdersManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

